import { Component, HostBinding, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ProductAmount, WizumenModel } from '../../wizumen-models';
import { MediaPictureService } from 'projects/common/services/media-picture.service';
import { Device } from 'projects/common/model/Device';
@Component({
  selector: 'wizumen-detail-header',
  template: `
    <div class="wizumen-detail flex-column" [ngClass]="{'full-height': showDestinationImage}">

      <div *ngIf="showDestinationImage" class="wizumen-desktop-destination-image-container">
        <img class="destination-image" [src]="destinationImageSource" (error)="destinationImageSource = getMediaSrc(fallbackMediaKey)" alt="destination image" loading="lazy"/>
      </div>

      <div *ngIf="showContent" class="content-container">
        <div class="desktop-left-content">
          <div *ngIf="!isTPV3Desktop" class="wizumen-detail-header-wrapper">
              <div class="wizumen-detail-header flex">
                <span class="wizumen-detail-content flex justify-space-between align-center">
                    <span class="wizumen-city -eva-3-bold">{{item.to}}</span>
                        <span *ngIf="item.booking_info" class="wizumen-booking-status-driver eva-3-driver {{layoutInfo}}">
                          <span class="driver-text">{{item.booking_info.description}}</span>
                        </span>
                </span>

                <wizumen-date-countdown class="wizumen-date-countdown" *ngIf="showDateAndPassengers" [item]="this.item" [isDesktop]="isDesktop"></wizumen-date-countdown>
              </div>
          </div>

          <span *ngIf="showProducts" class="wizumen-products-container">
            <div class="wizumen-products flex justify-space-between"
              [ngClass]="{'wizumen-V2': this.item.wizumen_v2}">
                <wizumen-product-icon *ngFor="let product of item.products" [product]="product" [isV2]="this.item.wizumen_v2"></wizumen-product-icon>
            </div>
          </span>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./wizumen-detail-header.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WizumenDetailHeaderComponent implements OnInit {
  @Input() isTPV3Desktop: boolean;
  @Input() isDesktopWizumenV2: boolean;

  @Input() item: WizumenModel;
  @Input() device: Device;
  @Input() layoutInfo: string;
  @Input() moduleId: string;
  @Input() moduleIndex: number;
  @Input() uniqueId: string;
  @Input() purchasedProductsAmount: ProductAmount[];
  @Input() missingProductsAmount: ProductAmount[];
  @Input() goToMyTravels: () => void;
  @Input() showProducts: boolean;
  @Input() showDateAndPassengers: boolean;
  @Input() showContent: boolean;
  @Input() hasTripPlanner: boolean;
  @HostBinding("class.full-height")
  @Input() showDestinationImage: boolean;

  isDesktop: boolean;
  destinationImageSource: string;
  fallbackMediaKey: string = "2fd7d0ee-6d53-4ea3-bcd4-ac619197dc99";
  constructor(private mediaPictureService: MediaPictureService) { }

  ngOnInit() {
    this.isDesktop = this.device.type === 'DESKTOP';
    if (this.item.wizumen_v2) {
      this.destinationImageSource = this.getMediaSrc(this.item.destination_media_key);
    }
  }

  public getMediaSrc(mediaKeyOrUrl: string): string {
    const size: string = !this.hasTripPlanner ? "630x458" : "420x272";
    return this.mediaPictureService.getMediaUrl(mediaKeyOrUrl, size) || "";
  }
}
